module.exports = __webpack_public_path__ + "img/52002764_L.e1fd2ea9.png";